export default "__VITE_ASSET__CNoykOP5__"